import type { ARModelData } from "@core/content/types";
import { ContentData as RawContentData } from "./data/data";

let resolvedContentData: ARModelData[] = RawContentData;

export function setContentData(data: ARModelData[]): void {
  resolvedContentData = data;
}

export function getContentData(): ARModelData[] {
  return resolvedContentData;
}
